<template>
    <div class="team-detail">
        <z-link
            v-if="nav['back-link']"
            class="team-detail__link"
            size="m"
            iconPosition="left"
            icon="arrow"
            :href="nav['back-link']"
            >{{ textDetail.linkText }}</z-link
        >

        <div class="team-detail__head u-top-margin--m">
            <div
                v-if="data.previewPicture"
                class="team-detail__image"
                :style="`background-image: url(${data.previewPicture.link})`"
            ></div>
            <div class="team-detail__person">
                <div>
                    <z-caption
                        tag="h2"
                        weight="600"
                        class="team-detail__name"
                        v-html="data.name"
                    ></z-caption>
                    <span class="team-detail__post" v-html="data.position.value"></span>
                </div>

                <p
                    v-if="data.startOfWork.value"
                    tag="span"
                    class="team-detail__date"

                > {{ textDetail.work }} {{data.startOfWork.value}}</p>
            </div>
        </div>
        <div class="team-detail__content">
            <z-blockquote
                class="team-detail__quote"
                :author="{
                    name: '',
                    info: '',
                    photo: ''
                }"
                :text="data.quote.value"
            />

            <z-caption
                v-if="data.historyOfSuccess.value"
                tag="h3"
                weight="600"
                class="team-detail__story-title"
                v-html="textDetail.story"
            ></z-caption>

            <vue-raw v-if="data.historyOfSuccess.value" class="team-detail__story" :raw="data.historyOfSuccess.value" />

            <z-video
                v-if="data.video.link || data.videoLink.value"
                class="team-detail__video"
                :autoplay="false"
                :src="data.video.link || data.videoLink.value"
            ></z-video>
        </div>

        <page-changer
            v-if="nav.prev || nav.next"
            class="team-detail__footer"

            :data="{ next: { name: nav.next ? nav.next.name : '', url: nav.next ?  nav.next.url : ''}, prev: { name: nav.prev ? nav.prev.name : '', url:  nav.prev ? nav.prev.url : ''} }"
        ></page-changer>
    </div>
</template>

<script>
import { textDetail } from './constans'

export default {
    name: 'team-detail',
    data () {
        return {
            data: this.$root.app.components['team-detail'].item,
            nav: this.$root.app.components['team-detail'].nav,
            textDetail
        }
    }
}
</script>

<style lang="scss">
.team-detail {
    &__link {
        color: #15386c;
        margin-right: 10px;
        font-weight: 600;
        font-size: 20px !important;
        line-height: 27px !important;
        margin-bottom: 48px;

        @media screen and(max-width: 480px) {
            margin-bottom: 12px;
        }

        .z-icon {
            transform: rotate(-90deg) !important;
        }
    }

    .z-blockquote blockquote {
        @include breakpoint (mobile) {
            font-size: 24px;
        }
    }

    &__head {
        display: flex;
        flex-direction: row;
        margin-bottom: 48px;

        @include breakpoint(v-tablet) {
            flex-direction: column;
        }
    }

    &__image {
        flex: 0 0 50%;
        max-width: calc(50% - 24px);
        border-radius: 5px;
        overflow: hidden;
        background-size: cover;
        background-position: 50% 50%;
        background-repeat: no-repeat;
        @include margin-level(right, M);

        &:after {
            content: '';
            display: block;
            padding-top: 100%;
        }
    }

    &__person {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        @include breakpoint(v-tablet) {
            flex: 0 0 100%;
            max-width: 100%;
            margin-top: $token-spacers-s;
            padding-left: 0;
        }
    }

    &__quote {
        margin-bottom: 64px;
    }

    &__name {
        font-size: 56px;
        color: $token-colors-black-80;
        line-height: 1.2;
        margin-bottom: 16px !important;

        @include breakpoint(mobile) {
            font-size: 24px;
        }
    }

    &__post {
        margin-top: $token-spacers-2-xs;
        color: $token-colors-black-60;
        font-weight: 500;
        font-size: 24px;
        line-height: 140%;
        margin-bottom: 8px;
        display: block;
    }

    &__date {
        color: $token-colors-black-40;
        font-weight: 500;
        font-size: 24px;
        line-height: 140%;
    }

    &__story-title {
        font-size: 40px;
        color: #2f2e34;
        line-height: 120%;
        margin-bottom: 24px !important;
    }

    &__story {
        margin-bottom: 64px !important;
    }

    &__video {
        margin-bottom: 64px;
    }

    &__footer {
        padding-top: 42px;
        border-top: 1px solid $token-colors-tertiary-15;
    }
}
</style>
